import React, { useState, useEffect } from 'react';
import Portal from './Portal';
import './Modal.css';

const TIPOS_PADRAO = [
  { value: 'cartao', label: '💳 Gastos com Cartão' },
  { value: 'fixo',   label: '📌 Gastos Fixos' },
  { value: 'outro',  label: '🗂 Outros' },
];

function Tooltip({ text }) {
  const [show, setShow] = useState(false);
  return (
    <span className="tooltip-wrap" onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      <span className="tooltip-icon">?</span>
      {show && <span className="tooltip-box">{text}</span>}
    </span>
  );
}

export default function ContaModal({ conta, tiposCustom = [], onSave, onClose }) {
  const [nome, setNome] = useState('');
  const [tipo, setTipo] = useState('fixo');
  const [tipoCustomId, setTipoCustomId] = useState('');
  const [fechamento, setFechamento] = useState('');
  const [vencimento, setVencimento] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (conta) {
      setNome(conta.nome || '');
      setFechamento(conta.fechamento_dia ? String(conta.fechamento_dia) : '');
      setVencimento(conta.vencimento_dia ? String(conta.vencimento_dia) : '');
      if (conta.tipo === 'custom' && conta.tipo_custom_id) {
        setTipo('custom');
        setTipoCustomId(conta.tipo_custom_id);
      } else {
        setTipo(conta.tipo || 'fixo');
        setTipoCustomId('');
      }
    }
  }, [conta]);

  function handleTipoChange(val) {
    if (val.startsWith('custom_')) {
      setTipo('custom');
      setTipoCustomId(val.replace('custom_', ''));
    } else {
      setTipo(val);
      setTipoCustomId('');
    }
  }

  // Valor do select
  const selectValue = tipo === 'custom' ? `custom_${tipoCustomId}` : tipo;

  async function handleSubmit(e) {
    e.preventDefault();
    if (!nome.trim()) { setError('Informe o nome da conta.'); return; }
    setSaving(true);
    await onSave({
      nome: nome.trim(),
      tipo,
      tipo_custom_id: tipoCustomId || null,
      fechamento_dia: fechamento ? parseInt(fechamento) : null,
      vencimento_dia: vencimento ? parseInt(vencimento) : null,
    });
    setSaving(false);
  }

  const isCartao = tipo === 'cartao';
  const allTipos = [
    ...TIPOS_PADRAO,
    ...tiposCustom.map(t => ({ value: `custom_${t.id}`, label: `${t.icone} ${t.nome}` }))
  ];

  return (
    <Portal>
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-box fade-in" onClick={e => e.stopPropagation()}>
          <div className="modal-header">
            <h3 className="modal-title">{conta ? 'Editar Conta' : 'Nova Conta'}</h3>
            <button className="modal-close" onClick={onClose}>✕</button>
          </div>

          <form onSubmit={handleSubmit} className="modal-form">
            <div className="form-group">
              <label>Nome da Conta</label>
              <input
                type="text"
                placeholder="Ex: Nubank, CPFL, Água..."
                value={nome}
                onChange={e => setNome(e.target.value)}
                autoFocus maxLength={80}
              />
            </div>

            <div className="form-group">
              <label>Tipo</label>
              <select value={selectValue} onChange={e => handleTipoChange(e.target.value)}>
                {allTipos.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
              </select>
            </div>

            {isCartao && (
              <div className="form-group">
                <label style={{ display:'flex', alignItems:'center', gap:6 }}>
                  Dia de Fechamento
                  <Tooltip text="Fechamento: dia em que o cartão encerra as compras do mês. As compras feitas após essa data vão para a fatura do próximo mês." />
                </label>
                <input type="number" placeholder="Ex: 05" value={fechamento}
                  onChange={e => setFechamento(e.target.value)} min="1" max="31" />
                <span className="field-hint">Dia em que o cartão fecha a fatura (opcional)</span>
              </div>
            )}

            <div className="form-group">
              <label style={{ display:'flex', alignItems:'center', gap:6 }}>
                Dia de Vencimento
                <Tooltip text={isCartao
                  ? "Vencimento: dia em que a fatura do cartão deve ser paga. Geralmente cai alguns dias após o fechamento."
                  : "Vencimento: dia em que o boleto ou conta vence e deve ser pago."} />
              </label>
              <input type="number" placeholder="Ex: 10" value={vencimento}
                onChange={e => setVencimento(e.target.value)} min="1" max="31" />
              <span className="field-hint">
                {isCartao ? 'Dia em que a fatura vence (opcional)' : 'Dia em que a conta vence (opcional)'}
              </span>
            </div>

            {error && <div className="alert alert-error">{error}</div>}

            <div className="modal-actions">
              <button type="button" className="btn btn-ghost" onClick={onClose}>Cancelar</button>
              <button type="submit" className="btn btn-primary" disabled={saving}>
                {saving ? <><span className="spinner" /> Salvando...</> : conta ? 'Salvar Alterações' : 'Criar Conta'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Portal>
  );
}
